import React from 'react';
import { formatQuoteExactDecimal } from '../components/QuoteDecimalInput';

const valueLabel = (values, target) => {
  if (!target) return 'Valeur non enregistrée';
  const keys = target === 'price' ? ['forcedUnitSellingPrice', 'effectiveUnitSellingPrice', 'calculatedUnitSellingPrice']
    : ['forcedCoefficient', 'effectiveCoefficient', 'calculatedCoefficient', 'inheritedCoefficient'];
  const key = keys.find(name => values?.[name] != null);
  if (!key) return 'Valeur non enregistrée';
  return `${formatQuoteExactDecimal(values[key])}${target === 'price' ? ' € HT' : ''}`;
};
export default function CompositionHistory({ editor, line }) {
  const events = (editor.model.forcingHistory || []).filter(event => String(event.lineId) === String(line.id)
    && (!event.scope || JSON.stringify(event.scope) === JSON.stringify(editor.entry.scope)));
  if (!events.length) return <p>{line.forceReason ? `Motif enregistré : ${line.forceReason}. Aucun détail d’audit disponible.` : 'Aucun forçage enregistré pour cette ligne.'}</p>;
  return <div className="quote-detail-history">{events.map(event => <article key={event.id}>
    <strong>{!event.target ? 'Réinitialisation du forçage (type non enregistré)' : <>{event.eventType === 'forcing_reset' ? 'Réinitialisation du ' : 'Forçage du '}{event.target === 'price' ? 'prix unitaire HT' : 'coefficient'}</>}</strong>
    <p>Ancienne valeur : {valueLabel(event.oldValues, event.target)}</p>
    <p>Nouvelle valeur : {valueLabel(event.newValues, event.target)}</p>
    {event.reason && <p>Motif : {event.reason}</p>}
    {event.eventAt && !Number.isNaN(Date.parse(event.eventAt)) && <time dateTime={event.eventAt}>{new Date(event.eventAt).toLocaleString('fr-FR')}</time>}
    {event.actor?.professionalName ? <p>Auteur : {event.actor.professionalName}</p> : event.userId != null && <p>Auteur : utilisateur #{event.userId}</p>}
  </article>)}</div>;
}
